import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Departemen',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Departemen',
        href: '/adm/dept',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_dept',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'id_dept',
        label: 'ID',
        sortable: true,
      },
      {
        key: 'nm_dept',
        label: 'Nama Dept',
        sortable: true,
      },
      {
        key: 'desc_dept',
        label: 'Deskripsi Dept',
      },
      {
        key: 'nama_pabrik',
        label: 'Pabrik',
      },
      {
        key: 'total_karyawan',
        label: 'Total Karyawan',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      dist_code: '',
      dist_company: '',
      dist_address: '',
      dist_email: '',
      dist_phone: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeDept(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchDept(context, params = null) {
    let result = await ApiGetRequest(`dept`, params);
    return !result.error ? result.data.object : [];
  },

  async getListDept({ commit, state }) {
    commit('changeDept', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      id_pabrik: data.id_pabrik ? data.id_pabrik : '',
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`dept`, params);
    commit('changeDept', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailDept({ commit }, payload = null) {
    commit('changeDept', {
      loading: true,
    });

    let result = await ApiGetRequest(`dept/${payload.id}`);
    commit('changeDept', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadLogoDept({ commit, state }, payload) {
    commit('changeDept', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-image`, payload);
    commit('changeDept', {
      loading: false,
    });

    if (!result.error) {
      commit('changeDept', {
        form: {
          ...data.form,
          logo: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeDept', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`dept/import`, {
      items: data.import_form || [],
    });

    commit('changeDept', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createDept({ commit, state, dispatch }) {
    commit('changeDept', {
      loading: true,
    });

    let result = await ApiPostRequest(`dept`, state.data.form);
    commit('changeDept', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateDept({ commit, state, dispatch }, payload = null) {
    commit('changeDept', {
      loading: true,
    });

    let result = await ApiPutRequest(`dept/${payload.id}`, state.data.form);

    commit('changeDept', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteDept({ commit, dispatch }, payload = null) {
    commit('changeDept', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`dept/${payload.id}`);
    commit('changeDept', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
